import React, {useState,useEffect} from "react";
import CheckList from '../../partials/CheckList/CheckList';
import QuizSingleSelect from './QuizSingleSelect.js';
import QuestionPopup from '../../partials/QuestionPopup/QuestionPopup';
import File from '../TeamCheckIn/file.svg'
import './BenchmarkQuiz.scss';
import Button from '../../partials/Button/Button.js';
import BackButton from "../../partials/Button/BackButton";
import HiddenPanel from '../../partials/HiddenPanel/index';
import BubbleTracker from "../../partials/BubbleTracker/BubbleTracker";

const BenchmarkingQuiz = props =>{
    const [questionId,setQuestionId] = useState(0)
    const [questions, setQuestions] = useState([]);
    const [currentChoice,setCurrentChoice] = useState(null)
    const [feedback, setFeedback] = useState(null);
    const [questionsCorrect, setQuestionsCorrect] = useState([])
    const [showAskTheTeam,setShowAskTheTeam] = useState(null)
    const [total, setTotal] = useState([])
    const [selectedCorrect,setSelectedCorrect] = useState(null)


    const data = props.data

    const correctIndex = questions[questionId]?.options.findIndex(x=>x.correct === true) ?? -1;

    let createQuestions = () =>{
        let newArray = []
        let newCorrectArr = []
        data.story[props.storyId].quizQuestions.map((item,i)=>{
            let teamMember = data.team.find(x =>x.key === item.teamMember)
            item.teamMemberData = teamMember
            newArray.push(item)
            newCorrectArr.push(null)
        })
        console.log(newCorrectArr)
        setQuestions(newArray)
    }

    let handleComplete = (i) =>{
        if (correctIndex === i) {
            setSelectedCorrect(true)
            setFeedback(questions[questionId].feedback.correct)
            let temp = total;
            temp[i] = true
            setTotal(temp)
        } else {
            setSelectedCorrect(false)
            setFeedback(questions[questionId].feedback.incorrect)
            let temp = total;
            temp[i] = false
            setTotal(temp)
        }
    }

    let handelNext = () =>{
        // if (currentChoice === correctIndex) {
            let newQArr = questionsCorrect
            newQArr[questionId] = true
            setQuestionsCorrect(newQArr)
            if(questions.length === questionId + 1){
                // console.log("done");
                props.storyComplete()
            }else{
                setQuestionId(questionId + 1)
            }
        // } else {

        // }
        setFeedback(null);
        setCurrentChoice(null)
    }
    let handelClose = ()=>{
        setFeedback(null)
    }

    useEffect(()=>{
        createQuestions()
    },[])
    // useEffect(()=>{
    //     console.log('current choice ', currentChoice)
    // },[currentChoice])
    // useEffect(()=>{
    //     console.log('feedback', feedback)
    // },[feedback])
    // useEffect(()=>{
    //     console.log(questionsCorrect)
    // },[questionsCorrect])
    useEffect(()=>{
        if(questions.length > 0) setTotal([...questions[questionId].options.map(x=>{return null})])
    },[questionId])
    useEffect(()=>{
        if(questions.length > 0) setTotal([...questions[questionId].options.map(x=>{return null})])
    },[questions])

    return(
        <div className="benchmark-quiz">
            <div className="quiz-checklist">
                <div>
                    <div className="back-btn-container back-btn" onClick={props.backClick}>
                                <BackButton text="Back"/>
                            </div>
                    <p className="header">{props.data.instructionText.quiz}</p>
                </div>
            </div>
            <div className="left-container left-checklist">
                <CheckList clickedCheckboxes={props.clickedCheckboxes} checklistItems={props.data.checklistItems} correctCheckBoxes={props.correctCheckBoxes} capabilities={props.data.capabilities}/>
            </div>
            <div className="right-container">
                <div className="quiz-container">
                    <div className="team-member-container">
                        {questions.length > 0 &&
                            <div className="team-member">
                                <div className="team-member-img-container">
                                    <img src={questions[questionId].teamMemberData.img} alt={questions[questionId].teamMemberData.alt} />
                                </div>
                                <p>{questions[questionId].teamMemberData.name}</p>
                                <p className="job">{questions[questionId].teamMemberData.job}</p>
                            </div>
                        }
                    </div>
                    {questions.length > 0 &&
                        <QuizSingleSelect data={questions[questionId]} currentChoice={currentChoice} setCurrentChoice={setCurrentChoice} total={total} handelClick={handleComplete}/>
                    }
                </div>
                <div className="quiz-question-counter-container">
                    <BubbleTracker total={questions.length} current={questionId} />
                </div>
            </div>

            <div className="quiz-btn-container">
                {/* <Button text="Continue" disabled={total.find(x=>x===true) === undefined} onClick={()=>handelNext()}></Button> */}
                { currentChoice !== null &&
                    <Button text="Continue" onClick={()=>handelNext()}></Button>
                }
            </div>
            <div className="capabilities-btn" onClick={props.showCapabilities}>
                    <p>Capabilities</p>
                    <img src={File} alt={"File Image"}/>
            </div>
            {/* {questions.length > 0 &&
                <div onClick={()=> setShowAskTheTeam(!showAskTheTeam)}>
                <HiddenPanel className={`ATT-container ${showAskTheTeam&& "show"} ${showAskTheTeam === false&& 'close'}`} button={"ASK THE TEAM"} >
                    <p>{questions[questionId].askText}</p>
                </HiddenPanel>
            </div>
            } */}
            {feedback !== null &&
                <QuestionPopup data={feedback} onClose={handelClose} correct={selectedCorrect}/>
            }
        </div>
    )
}

export default BenchmarkingQuiz;